module.exports = __webpack_public_path__ + "img/GAME_CATCHTHEMOLE1.006ee5fe.jpg";